import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Comments|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

export type SPCandidateSystemActivityCommentsLocNames =
	| 'SPCandidateSystemActivityCommentsTitle'
	| 'SPCandidateSystemActivityCommentsSectionTitle'
	| 'SPCandidateSystemActivityCommentsButtonAddComment'
	| 'SPCandidateSystemActivityCommentsNotificationChangesSaved';

export const spCandidateSystemActivityCommentsLocs: LocDefs<SPCandidateSystemActivityCommentsLocNames> =
	{
		SPCandidateSystemActivityCommentsTitle: {
			defaultValue: 'Candidate Comments',
			description: 'Title',
			displayPath: `${pathStart}Title`,
			displayType: 'Title',
			legacyName: 'Core/Candidates.Comments.Title.TabTitle',
			...sharedProperties,
		},
		SPCandidateSystemActivityCommentsSectionTitle: {
			defaultValue: 'Candidate Comments',
			description: 'Section title',
			displayPath: `${pathStart}Section Title`,
			displayType: 'Title',
			legacyName: 'Core/Candidates.Comments.Title.SectionTitle',
			...sharedProperties,
		},
		SPCandidateSystemActivityCommentsButtonAddComment: {
			defaultValue: 'Add Comment',
			description: 'Button to add a comment',
			displayPath: `${pathStart}Button to add a comment`,
			displayType: 'Button',
			legacyName: 'Core/Candidates.Comments.Button.AddComment',
			...sharedProperties,
		},
		SPCandidateSystemActivityCommentsNotificationChangesSaved: {
			defaultValue: 'Changes made',
			description: 'Notification message for changes saved',
			displayPath: `${pathStart}Changes Saved`,
			displayType: 'Notification',
			legacyName: 'Core/Candidates.Comments.Notification.ChangesSaved',
			...sharedProperties,
		},
	};

export const spCandidateSystemActivityCommentsLocKeys =
	MapLocKeys<SPCandidateSystemActivityCommentsLocNames>(spCandidateSystemActivityCommentsLocs);

export type SPCandidateSystemActivityCommentsLocType =
	LocMap<SPCandidateSystemActivityCommentsLocNames>;
